import React from 'react';
import { AccountDetailsProps } from './types';
import { styles } from './styles';
import { Button, Spinner } from '@v2/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle, faRedo, faEdit } from '@fortawesome/free-solid-svg-icons';
import AccountField from '../AccountField';

const AccountDetails: React.FC<AccountDetailsProps> = ({
  account,
  loading,
  error,
  onRetry,
  onClose,
  onEdit,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Account Details</h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          aria-label="Close panel"
          icon={<FontAwesomeIcon icon={faTimes} className={styles.closeIcon} />}
        />
      </div>

      <div className={styles.content}>
        {loading && (
          <div className={styles.stateContainer}>
            <Spinner size="lg" className="tw-text-indigo-600 tw-mb-3" />
            <p className={styles.stateMessage}>Loading account details...</p>
          </div>
        )}

        {!loading && (error || !account) && (
          <div className={styles.stateContainer}>
            <FontAwesomeIcon
              icon={faExclamationCircle}
              className="tw-text-4xl tw-text-red-400 tw-mb-3"
            />
            <p className={styles.stateMessage}>There was an error fetching the account details.</p>
            <Button
              variant="outline"
              size="sm"
              onClick={onRetry}
              icon={<FontAwesomeIcon icon={faRedo} />}
            >
              Retry
            </Button>
          </div>
        )}

        {!loading && !error && account && (
          <>
            <div className={styles.fieldContainer}>
              <AccountField label="Name">
                {account.firstName} {account.lastName}
              </AccountField>
              <AccountField label="Email">
                {account.email}
              </AccountField>
              <AccountField label="Role">
                {account.role}
              </AccountField>
              {account.partners.length > 0 && (
                <AccountField label="Partners">
                  {account.partners.map((partner) => partner.name).join(', ')}
                </AccountField>
              )}
            </div>
            <div className={styles.actionsContainer}>
              <Button
                variant="primary"
                size="md"
                onClick={onEdit}
                icon={<FontAwesomeIcon icon={faEdit} />}
              >
                Edit Account
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AccountDetails;
